module.exports = __webpack_public_path__ + "static/media/mursion-mark-1024.da4fe3a3.png";